import { render } from "./out-of-stocks.vue?vue&type=template&id=550e17ce"
import script from "./out-of-stocks.vue?vue&type=script&lang=js"
export * from "./out-of-stocks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__